import { environment } from 'appEnv/environment';

export interface FeatureFlagMap {
    [flag: string]: boolean;
}

export class FeatureFlagStore {
    private static flags: FeatureFlagMap = FeatureFlagStore.seed();

    private static seed(): FeatureFlagMap {
        return { ...environment.features } as FeatureFlagMap;
    }

    static overlay(remote: FeatureFlagMap): void {
        if (!remote) {
            return;
        }

        Object.keys(remote).forEach((flag: string) => {
            FeatureFlagStore.flags[flag] = !!remote[flag];
        });
    }

    static get(flag: string): boolean {
        return FeatureFlagStore.flags.hasOwnProperty(flag) ? FeatureFlagStore.flags[flag] : false;
    }

    static snapshot(): FeatureFlagMap {
        return { ...FeatureFlagStore.flags };
    }

    static reset(): void {
        FeatureFlagStore.flags = FeatureFlagStore.seed();
    }
}
